import { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // ✅ IMPORTANT
import "./ComplexReactionLogin.css";

const ComplexReactionLogin = () => {
useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  const navigate = useNavigate();
    useEffect(() => {

    const email = localStorage.getItem("user_email");
     console.log("📧 EMAIL FROM LOCALSTORAGE:", email); 

    if (!email) {
      navigate("/");
      return;
    }
     console.log("🚀 CALLING API with test:", "complex_reaction"); // ✅ ADD HERE


    axios.get(`/check-access`, {
        params: {
          email: email,
          test: "complex_reaction"
        }
      })
      .then(res => {

        if (!res.data.allowed) {
          alert("Access denied");
          navigate("/");
        }

      })
      .catch(() => navigate("/"));

  }, []);



  return (
    <div className="rg-login-wrapper">

      {/* ================= HEADER SECTION ================= */}
      <div className="reaction-header-card">

        <h2 className="reaction-title">Reaction Speed (Complex)</h2>

        <p className="reaction-subtitle">
          Complex reaction speed measures how fast you can recognize,
          decide, and respond correctly when multiple signals are possible.
          It’s not just reacting — it’s
          <strong> “See → Decide → Execute.”</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Multiple visual stimuli → Correct decision response</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY SECTION ================= */}

        <div className="reaction-why-card">

          <h3 className="why-title">
            Why complex reaction speed matters in sport
          </h3>

          <p className="why-description">
            Real game situations require decision-making under pressure.
            You must read cues, filter distractions, choose the correct option,
            and act instantly. Complex reaction speed measures your cognitive
            processing under competitive speed.
          </p>

          <div className="why-tags">
            <span>Faster decision making</span>
            <span>Better anticipation</span>
            <span>Smarter positioning</span>
            <span>Reduced hesitation</span>
            <span>Improved game IQ</span>
          </div>

        </div>

      </div>

      {/* ================= HOW GAME WORKS ================= */}

      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">
          <li>
            A circle will appear in different colors.
          </li>

          <li>
            Click ONLY when the circle turns <strong>GREEN.</strong>
          </li>

          <li>
            Ignore <strong>RED</strong> and <strong>BLUE</strong>.
          </li>

          <li>
            You will get <strong>5 attempts</strong> and your reaction time will be recorded.
          </li>

          <li>
            Faster correct reactions improve your score.
          </li>
        </ul>

        <p className="how-note">
          Best practice: use the same device and posture when comparing results.
        </p>

      </div>

      {/* ================= START TEST ================= */}

      <div className="start-test-section">

        <h2>Ready to test your reaction?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/complex-reaction/play")}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default ComplexReactionLogin;